import { useNotificationSettingsContext } from '../contexts/NotificationSettingsContext';

/**
 * Hook do dostępu do ustawień powiadomień
 * Wrapper nad NotificationSettingsContext dla łatwego użycia w komponentach
 * 
 * @returns {Object} { settings, isLoading, error, updateNotificationSetting, toggleNotification, refetch }
 */
export function useNotificationSettings() {
  return useNotificationSettingsContext();
}

export default useNotificationSettings;







